module.exports = __webpack_public_path__ + "img/rongYu5.385c34dc.png";